<template>
  <div class="nasal-swab-check">
    <el-card>
      <div>
        <help-tooltip v-if="warnings.length" type="warning">
          <span v-for="warning in warnings" :key="warning.message">
            {{ warning.message }}
            <br>
          </span>
        </help-tooltip>
        <span>
          Was Nasal Swab taken ?
        </span>
      </div>
    </el-card>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';

import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'nasal-swab-check',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(warning => warning.metadata && warning.metadata.checkKey === this.ikey);

      return uniqBy(warnings, 'message');
    },
  },
  beforeMount() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'PROCEDURE',
        id: 'NASAL_SWAB',
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.nasal-swab-check, .el-card {
  width: 100%;
  color: black;
}
</style>
